import { JSBridgeCore } from '../core/JSBridgeCore'
import { DeviceInfo } from '../typings/DeviceInfo'
import { JSBridgeReturnType } from '../typings/JSBridgeProtocol'
import { OpenWebViewEnum } from '../typings/OpenWebViewEnum'
import { ShareConfig } from '../typings/ShareConfig'
import { UserInfo } from '../typings/UserInfo'
import { WebViewState, OrientationEnum } from '../typings/WebViewState'
import { WebViewTypeEnum } from '../typings/WebViewTypeEnum'
import { StaticData } from '../typings/StaticData'

/**
 * 浏览器端的jsbridge
 */
export class JSBridgeBrowser extends JSBridgeCore {
  webViewType: WebViewTypeEnum = WebViewTypeEnum.Browser

  ready(): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([true, null])
  }
  callAndBackfeed<T>(schemeUrl: string): Promise<JSBridgeReturnType<false | T>> {
    return Promise.resolve([false, null])
  }
  callAndListen<T>(schemeUrl: string, callback: (data: T) => void): Promise<JSBridgeReturnType<false | (() => void)>> {
    return Promise.resolve([() => void 0, null])
  }
  loadProgress(progress: number): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([true, null])
  }
  closeLoading(): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([true, null])
  }
  getDeviceInfo(): Promise<JSBridgeReturnType<false | DeviceInfo>> {
    return Promise.resolve([false, null])
  }
  getStaticData(): Promise<JSBridgeReturnType<false | StaticData>> {
    return Promise.resolve([false, null])
  }
  getWebViewState(): Promise<JSBridgeReturnType<false | WebViewState>> {
    return Promise.resolve([false, null])
  }
  setLeftTopBackButton(enable: boolean): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  login(): Promise<JSBridgeReturnType<false | UserInfo>> {
    return Promise.resolve([false, null])
  }
  logout(): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  getUserInfo(): Promise<JSBridgeReturnType<false | UserInfo>> {
    return Promise.resolve([false, null])
  }
  openWebView(url: string, way: OpenWebViewEnum): Promise<JSBridgeReturnType<boolean>> {
    switch (way) {
      case OpenWebViewEnum.Replace:
      case OpenWebViewEnum.Single: {
        setTimeout(() => globalThis.location.replace(url), 200)
        break
      }
      case OpenWebViewEnum.Append:
      default: {
        setTimeout(() => (globalThis.location.href = url), 200)
        break
      }
    }
    return Promise.resolve([true, null])
  }
  closeWebView(): Promise<JSBridgeReturnType<boolean>> {
    globalThis.close()
    return Promise.resolve([true, null])
  }
  getBangsHeight(): Promise<JSBridgeReturnType<number | false>> {
    return Promise.resolve([0, null])
  }
  setOrientation(orientation: OrientationEnum): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  keepScreenLight(enable: boolean): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  shock(duration?: number): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  minimize(): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  saveImage2Album(base64: string): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  detectMicro(): Promise<JSBridgeReturnType<boolean>> {
    return new Promise<JSBridgeReturnType<boolean>>((resolve) => {
      const rule = { audio: true, video: false }
      try {
        globalThis.navigator.mediaDevices
          .getUserMedia(rule)
          .then(() => resolve([true, null]))
          .catch((e) => resolve([false, e]))
      } catch (e) {
        console.error(e)
        resolve([false, e as Error])
      }
    })
  }
  actionShare(shareConfig: Partial<ShareConfig>): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  preload(urls: string[]): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }
  createCacheProxyUrl(urls: string | string[]): string[] {
    return []
  }
}
